const STOREFRONT_REFRESH_STORAGE_KEY = 'panchali:storefront-refresh';
const STOREFRONT_REFRESH_EVENT = 'panchali:storefront-refresh';

const matchesScope = (scope = 'all', acceptedScopes = ['all']) =>
  acceptedScopes.includes('all') || scope === 'all' || acceptedScopes.includes(scope);

const parseRefreshDetail = (rawValue) => {
  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch (error) {
    return null;
  }
};

export const bindStorefrontRefresh = (
  callback,
  { scopes = ['all'], minIntervalMs = 15000 } = {}
) => {
  if (typeof window === 'undefined' || typeof callback !== 'function') {
    return () => {};
  }

  let lastRunAt = 0;

  const runCallback = (force = false) => {
    const now = Date.now();

    if (!force && now - lastRunAt < minIntervalMs) {
      return;
    }

    lastRunAt = now;
    callback();
  };

  const handleRefreshDetail = (detail) => {
    if (!detail || !matchesScope(detail.scope, scopes)) {
      return;
    }

    runCallback(true);
  };

  const handleStorage = (event) => {
    if (event.key !== STOREFRONT_REFRESH_STORAGE_KEY) {
      return;
    }

    handleRefreshDetail(parseRefreshDetail(event.newValue));
  };

  const handleCustomEvent = (event) => {
    handleRefreshDetail(event.detail);
  };

  const handleFocus = () => {
    runCallback(false);
  };

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      runCallback(false);
    }
  };

  window.addEventListener('storage', handleStorage);
  window.addEventListener(STOREFRONT_REFRESH_EVENT, handleCustomEvent);
  window.addEventListener('focus', handleFocus);
  document.addEventListener('visibilitychange', handleVisibilityChange);

  return () => {
    window.removeEventListener('storage', handleStorage);
    window.removeEventListener(STOREFRONT_REFRESH_EVENT, handleCustomEvent);
    window.removeEventListener('focus', handleFocus);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };
};
